import React from 'react';
import {DatePicker, RaisedButton, DropDownMenu, MenuItem, Tabs, Tab, Paper} from 'material-ui';
import ObservationWaterLevel from './ObservationWaterLevel';
import ObservationRainfall from './ObservationRainfall';
import {toJS} from "mobx";

class Observation extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      date: new Date(),
      observations: null,
      period: 'Hourly',
      data: {
        data: [],
        categories: [],
        seriesData: [],
      },
      titleText: '',
      options: null,
      waterLevelId: null,
      rainfallId: null,
      thresholds: null,
      mobView: null
    };
  }

  componentWillMount(){
    let {waterLevelId, rainfallId, thresholds, mobView} = this.props;
    this.setState({waterLevelId, rainfallId, thresholds, mobView})
  }

  componentWillReceiveProps(nextProps) {
    let {waterLevelId, rainfallId, thresholds, mobView} = this.props;
    if (this.props.series_id !== nextProps.series_id) {
      console.log('received next props');
      this.onView(nextProps.series_id);
    }
    if(+waterLevelId !== +nextProps.waterLevelId) {
      this.setState({waterLevelId: nextProps.waterLevelId});
    }
    if(+rainfallId !== +nextProps.rainfallId) {
      this.setState({rainfallId: nextProps.rainfallId});
    }
    if(thresholds != nextProps.thresholds) {
      this.setState({thresholds: nextProps.thresholds});
    }
    if(mobView !== nextProps.mobView) {
      this.setState({mobView: nextProps.mobview});
    }
  }

  onChangeDate = (x, date) => this.setState({date});

  onChangePeriod = (event, index, value) => {
    this.setState({period: value});
  };

  onView = () => {
    this.setState({
      date: this.state.date,
      period: this.state.period
    });
  };

  getSettings = () => {
    if (this.props.mobView) {
      const theadStyle = {color: '#0f72a9'};
      return (
        <table style={{width: '100%', borderBottom: '1px lightgray solid'}}>
          <thead>
          <tr style={{width: '100%'}}>
            <th style={theadStyle}>DATE</th>
            <th style={theadStyle}>PERIOD</th>
            <th>{' '}</th>
          </tr>
          </thead>
          <tbody style={{width: '100%'}}>
          <tr>
            <td>
              <DatePicker id="datepicker" textFieldStyle={{width: '80%'}} onChange={this.onChangeDate} autoOk={true}
                          maxDate={new Date()} value={this.state.date}/>
            </td>
            <td>
              <DropDownMenu value={this.state.period} onChange={this.onChangePeriod}>
                <MenuItem value={'Point'} primaryText="Point"/>
                <MenuItem value={'Hourly'} primaryText="Hourly"/>
                <MenuItem value={'Daily'} primaryText="Daily"/>
              </DropDownMenu>
            </td>
            <td><RaisedButton label='View' primary={true} onClick={this.onView}/></td>
          </tr>
          </tbody>
        </table>
      );
    } else {
      return (
        <table className="" style={{width: '100%', borderBottom: '1px lightgray solid'}}>
          <tbody style={{width: '100%'}}>
          <tr style={{width: '100%'}}>
            <th style={{color: '#0f72a9'}}>DATE</th>
            <td>
              <DatePicker id="datepicker" textFieldStyle={{marginLeft: '20px', width: '50%'}}
                          onChange={this.onChangeDate} autoOk={true} maxDate={new Date()} value={this.state.date}/>
            </td>
            <th style={{color: '#0f72a9'}}>PERIOD</th>
            <td>
              <DropDownMenu value={this.state.period} onChange={this.onChangePeriod}>
                <MenuItem value={'Point'} primaryText="Point"/>
                <MenuItem value={'Hourly'} primaryText="Hourly"/>
                <MenuItem value={'Daily'} primaryText="Daily"/>
              </DropDownMenu>
            </td>
            <td>
              <RaisedButton label='View' primary={true} onClick={this.onView}/>
            </td>
          </tr>
          </tbody>
        </table>
      );
    }
  };

  render() {
    let {waterLevelId, rainfallId, date, period, thresholds, mobView} = this.state;
    return (
      <div style={{paddingBottom: '10px'}}>
        <h5 className="myTableHead">Observation</h5>
        <div style={{padding: '0 10px 10px 10px'}}>
          {this.getSettings()}
          <br/>
          {this.props.mobView ?
            <Paper>
              <Tabs>{waterLevelId &&
              <Tab label='Water Level'>
                <ObservationWaterLevel series_id={waterLevelId} date={date} period={period} mobView={mobView} thresholds={thresholds} />
              </Tab>}{rainfallId &&
              <Tab label='Rainfall'>
                <ObservationRainfall series_id={rainfallId} date={date} period={period} mobView={mobView} />
              </Tab>}
              </Tabs>
            </Paper>:
            <div className="column-it">{waterLevelId &&
              <Paper zDepth={1}>
                <h5 className="myTableHead">Water Level</h5>
                <ObservationWaterLevel series_id={waterLevelId} date={date} period={period} mobView={mobView} thresholds={thresholds} />
              </Paper>}<br/>{rainfallId &&
              <Paper zDepth={1}>
                <h5 className="myTableHead">Accumulated Rainfall</h5>
                <ObservationRainfall series_id={rainfallId} date={date} period={period} mobView={mobView} />
              </Paper>}
            </div>}
        </div>
      </div>
    );
  }
}

export default Observation;



// WEBPACK FOOTER //
// ./src/components/Station/Observation.js